import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-qiyexinxi-h",
  "use": "icon-qiyexinxi-h-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" id=\"icon-qiyexinxi-h\">\n  <path d=\"M3 21h18\" />\n  <path d=\"M5 21V7l8-4v18\" />\n  <path d=\"M19 21V11l-6-4\" />\n  <path d=\"M9 9v.01\" />\n  <path d=\"M9 12v.01\" />\n  <path d=\"M9 15v.01\" />\n  <path d=\"M9 18v.01\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/qiyexinxi-h.svg
// module id = u3mB
// module chunks = 96